import React, { Component } from 'react'

var classNames = require('classnames');

export default class Animation extends Component {
    state = {
        animationState: 0
    };

    animationTextClass( state ) {
        return classNames( "z-10 absolute transition transition-limit sichkovskyi__hero-text_1 text-5xl text-grey-lighter text-center font-bold",
            {
                "opacity-0": state !== this.state.animationState
            }
        )
    }

    componentDidMount() {
        this.animationChangeInterval = setInterval(() => {
            if ( this.state.animationState === 3 ) {
                clearInterval( this.animationChangeInterval );
                return;
            }

            this.setState( { "animationState": this.state.animationState + 1 } );
        }, 5000);
    }

    render() {
        return (
            <React.Fragment>
                <p className={this.animationTextClass(1)}>Hi, I'm Yurii 🙃</p>
                <p className={this.animationTextClass(2)}>a freelance full-stack web developer.</p>
                <p className={this.animationTextClass(3)}>Let's build beautiful web-apps together!</p>

                <div className="absolute sichkovskyi__animation-container z-0">

                    <div className="sichkovskyi__blur-container">
                        <svg viewBox="0 0 558 558">
                            <g id="circle" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <circle id="base" fill="#B7FB6D" cx="279" cy="279" r="278"></circle>
                                <circle id="layer-1" fill="#B7FB6D" cx="279" cy="279" r="278"></circle>
                                <circle id="layer-2" fill="#B7FB6D" cx="279" cy="279" r="278"></circle>
                                <circle id="layer-3" fill="#B7FB6D" cx="279" cy="279" r="278"></circle>
                                <circle id="layer-4" fill="#B7FB6D" cx="279" cy="279" r="278"></circle>
                                <circle id="layer-5" fill="#B7FB6D" cx="279" cy="279" r="278"></circle>
                                <circle id="layer-6" fill="#B7FB6D" cx="279" cy="279" r="278"></circle>
                                <circle id="layer-7" fill="#B7FB6D" cx="279" cy="279" r="278"></circle>
                                <circle id="layer-8" fill="#B7FB6D" cx="279" cy="279" r="278"></circle>
                            </g>
                        </svg>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
